getTokenKindDesc